import Common from './common';
import Events from './events';

// Utilisation de $ pour Jquery
window.$ = jQuery;

// Initialisation de la classe Common, utilisée pour tout le site
let global = new Common();

$(document).ready(function(){
    global.modalNlOpen();
    global.modalNlClose();

//uniquement sur la page des évènements
    if ($('body').hasClass('single-events')) {
        let event = new Events();
        event.init();
    }
});